module.exports = __webpack_public_path__ + "img/2015ninahui.152d2ca5.png";